import { EntityContentLayoutBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export { EntityRelationWarning } from './entity-relation-warning';
export type { EntityRelationWarningProps } from './entity-relation-warning';

export const entityContentLayout: ExtensionDefinition =
  EntityContentLayoutBlueprint.make({
    name: 'default',
    params: {
      loader: async () =>
        import('./entity-content-layout').then(m => m.EntityContentLayout),
    },
  });
